import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import { FOOTER_NAV_LINKS } from '../../Config/routes';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

const SOCIAL_LINKS = [
  {
    label: 'Facebook',
    url: '#',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  {
    label: 'X (Twitter)',
    url: '#',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: 'YouTube',
    url: '#',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58a2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58zM9.75 15.02V8.98L15.5 12z" />
      </svg>
    ),
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navRef = useAnimateOnScroll(0.2);
  const socialRef = useAnimateOnScroll(0.2);

  return (
    <footer className="footer">
      <div className="footer__inner">
        <nav ref={navRef} className="footer__nav">
          {FOOTER_NAV_LINKS.map((link) => (
            <Link key={link.path} className="footer__nav-link slide-down" to={link.path}>
              {link.label}
            </Link>
          ))}
        </nav>

        <div ref={socialRef} className="footer__social">
          {SOCIAL_LINKS.map((social) => (
            <a
              key={social.label}
              className="footer__social-link scale-in"
              href={social.url}
              aria-label={social.label}
              target="_blank"
              rel="noopener noreferrer"
            >
              {social.icon}
            </a>
          ))}
        </div>

        <div className="footer__bottom">
          <span className="footer__copyright">&copy; Copyright {currentYear}</span>
          <span className="footer__credit">
            Crafted with <span className="footer__heart">&hearts;</span> by{' '}
            <a
              href="https://www.appcastlehub.com/home"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__credit-link"
            >
              Appcastlehub.com
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
